exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cards .block{display:flex;flex-direction:column}.Cards .block-center{width:100%;display:flex;align-items:center;justify-content:center;height:60vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/CardTrashed/components/Cards/style.scss
// module id = 5143
// module chunks = 0